<section class="clsChatScreen clsForm">
  <div class="clsChatHeader d-flex justify-content-between align-items-center"></div>
  <div class="clsChatConversation" role="img">
    <div class="row">
      <div class="col-xl-4">
        <div class="search">
          <input class="form-control" type="text" placeholder="Search By Name" aria-label="compose"
            (keyup)="searchUser($event)" />
          <i class="fa fa-search" aria-hidden="true"></i>
        </div>
        <div class="clsLeftChat card">
          <div class="clsUsersList">
            <ng-container *ngFor="let user of filteredUserList">
              <div class="media" [ngClass]="{ active: +user.id === +selectedUserId }"
                (click)="onSelectUser(user.id, user.fullname)">
                <div class="media-left pr-3">
                  <div class="clsTxtProfile clsProfile clsTxtProfileBg-2">
                    <p class="m-0">{{ user.abbrevation }}</p>
                    <span [ngClass]="isOnline(user.id) ? 'clsOnline' : ' clsOnline clsOffline'"></span>
                  </div>
                </div>
                <div class="media-body">
                  <h6 class="clsUserName clearfix">
                    <span class=""> {{ user.fullname }} </span>
                    <span class="clsCount" *ngIf="+user.unread_messages"> {{ user.unread_messages }} </span>
                  </h6>

                  <div class="clearfix clsDateCase">
                    <p class="clsDate">
                      {{ user.createdat | date : 'shortTime' }} , {{ user.createdat | date : 'shortDate' }}
                    </p>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>

      <div class="col-xl-8" [hidden]="selectedUserId">
        <div class="clearfix text-right mb-10">
          <p-button label="New User" data-toggle="modal" data-target="#newuserModal"
            tooltipPosition="bottom"></p-button>
        </div>
        <div class="d-flex justify-content-center align-items-center clsChatNotSelct">
          <h5>Please Select User to start Chatting</h5>
        </div>
      </div>

      <div class="col-xl-8" [hidden]="!selectedUserId">
        <div class="clearfix text-right mb-10">
          <p-button label="New User" data-toggle="modal" data-target="#newuserModal"></p-button>
        </div>
        <div class="chat-head">
          <div class="media">
            <div class="media-left pr-3">
              <div class="clsTxtProfile clsProfile clsTxtProfileBg-2">
                <p class="m-0">{{ selectedUserAbbrevation }}</p>
              </div>
            </div>
            <div class="media-body">
              <h6 class="clsUserName">{{ selectedUserName }}</h6>
              <p class="clsUserMsg m-0">{{ isOnline(selectedUserId) ? 'Online' : getUserSession(selectedUserId) }}</p>
            </div>
            <div class="media-right">
              <div class="icons-two">
                <i class="fa fa-times-circle" aria-hidden="true" (click)="resetChatWindow()"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="clsRightChat">
          <div class="clsRightChatBody" #messages [scrollTop]="messages.scrollHeight">
            <ng-container *ngFor="let message of selectedUserChat; let i = index">
              <div [ngClass]="+message.sender_id === userId ? 'clsSentMsg clsChatMsg' : 'clsRepliesMsg clsChatMsg'">
                <div class="cls-today" *ngIf="
                    i === 0 ||
                    (message.createdat | date : 'dd MMMM yyyy') !==
                      (selectedUserChat[i - 1].createdat | date : 'dd MMMM yyyy')
                  ">
                  <p>{{ getMessageDate(i) }}</p>
                </div>

                <div class="clsMsg" *ngIf="!message.document_info?.document_url">
                  <div class="clsUserIcon">
                    <div class="content">
                      <p class="m-0">{{ message.message }}</p>

                      <div class="clsTime">
                        <p>
                          {{ message.createdat | date : 'shortTime' }}
                          <span class="read" *ngIf="+message.sender_id === userId && !message.isread">
                            <i class="fa fa-check" aria-hidden="true"></i>
                          </span>
                          <span class="read" *ngIf="+message.sender_id === userId && message.isread">
                            <i class="fa fa-check-circle-o" aria-hidden="true"></i>
                          </span>
                        </p>
                      </div>
                    </div>

                    <div class="clsTxtProfile clsProfile clsTxtProfileBg-2">
                      <p class="m-0">
                        {{
                        +message.sender_id === userId
                        ? chatService.getAbbrevation(userInfo?.firstname + ' ' + userInfo.lastname)
                        : selectedUserAbbrevation
                        }}
                      </p>
                    </div>
                  </div>
                </div>

                <div class="doc-flex" *ngIf="message.document_info?.document_url">
                  <div class="clsUserIcon">
                    <div class="document-profile">
                      <div class="media">
                        <div class="media-left pr-3">
                          <div class="doc-img">
                            <i [class]="chatService.getFileExtension(message?.document_info?.document_type)?.icon"
                              aria-hidden="true"></i>
                          </div>
                        </div>
                        <div class="media-body">
                          <h6 class="value-text">{{ message.document_info?.document_name }}</h6>
                          <p class="clspdf m-0">
                            {{ chatService.getFileExtension(message?.document_info?.document_type)?.extension }}
                            {{ chatService.formatBytes(message?.document_info?.document_size) }}
                            <span class="ml-10">
                              <i class="fa fa-download" aria-hidden="true" (click)="
                                  downloadFile(
                                    message.document_info?.document_url,
                                    message.document_info?.document_name
                                  )
                                "></i>
                            </span>
                          </p>
                        </div>
                      </div>
                      <div class="clearfix clsApproveReject" [hidden]="+userId !== +message.receiver_id"></div>
                      <div class="clsTime">
                        <p>
                          {{ message.createdat | date : 'shortTime' }}
                          <span class="ml-10 read" *ngIf="+message.sender_id === userId && !message.isread">
                            <i class="fa fa-check" aria-hidden="true"></i>
                          </span>
                          <span class="ml-10 read" *ngIf="+message.sender_id === userId && message.isread">
                            <i class="fa fa-check-circle-o" aria-hidden="true"></i>
                          </span>
                        </p>
                      </div>
                    </div>

                    <div class="clsTxtProfile clsProfile clsTxtProfileBg-2">
                      <p class="m-0">
                        {{
                        +message.sender_id === userId
                        ? chatService.getAbbrevation(userInfo?.firstname + ' ' + userInfo.lastname)
                        : selectedUserAbbrevation
                        }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>

            <div class="clsRepliesMsg clsChatMsg" [hidden]="!isReceiverTyping">
              <div class="clsMsg">
                <div class="content">
                  <div class="typing">
                    <div class="dot"></div>
                    <div class="dot"></div>
                    <div class="dot"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="clsRightChatFooter" [formGroup]="chatForm">
            <div class="media align-items-center">
              <div class="media-body clsTypeMsg">
                <label for="file-input" class="form-control">
                  <input #onTyping class="form-control-input" type="text" placeholder="Compose your Message..."
                    aria-label="compose" (keyup.enter)="sendMessage()" formControlName="message" />
                </label>
              </div>
              <div class="media-right">
                <button type="button" class="btn btn-primary" (click)="sendMessage()">
                  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M20.0899 8.00104L3.63484 0.259788C2.70534 -0.192129 1.60992 -0.0362954 0.840839 0.654871C0.0699221 1.34879 -0.197745 2.42679 0.157922 3.40029C0.173505 3.4397 4.20134 11.005 4.20134 11.005C4.20134 11.005 0.247755 18.5684 0.234005 18.6069C-0.120745 19.5813 0.149672 20.6575 0.920589 21.3505C1.39817 21.7785 2.00134 21.9995 2.60817 21.9995C2.98309 21.9995 3.35892 21.9151 3.70909 21.7437L20.0918 14.0089C21.2697 13.4561 22.0012 12.3048 22.0003 11.004C22.0003 9.70237 21.266 8.55104 20.0899 8.00104ZM1.86292 2.72104C1.75109 2.34062 1.98942 2.08854 2.06734 2.01704C2.14892 1.94462 2.44684 1.72004 2.83551 1.9107C2.84009 1.91254 19.3117 9.66112 19.3117 9.66112C19.5308 9.76379 19.7132 9.90862 19.8534 10.0846H5.78901L1.86292 2.72104ZM19.3108 12.3497L2.91342 20.0919C2.52384 20.2835 2.22684 20.0598 2.14526 19.9855C2.06642 19.9159 1.82809 19.662 1.94084 19.2806L5.79267 11.918H19.8589C19.7187 12.0967 19.5326 12.2452 19.3108 12.3497Z"
                      fill="white" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Modal -->
<div class="modal fade" id="newuserModal" data-backdrop="static" data-keyboard="false" tabindex="-1"
  aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-xl">
    <div class="modal-content">
      <div class="modal-body">
        <app-new-user (selectedNewUser)="selectedNewUser($event)"> </app-new-user>
      </div>
    </div>
  </div>
</div>
